import React from "react";
import { useTranslation } from "react-i18next";
import {
  getAdminTabMetricColumns,
  type AdminTabMetricColumnsContext,
} from "../../config/adminTabMetricColumns";
import type { AdminHotelMetricRow } from "../../types/adminHotelMetricTable";
import { AdminHotelsMetricTable } from "../shared/AdminHotelsMetricTable";

type AdminTeamHotelsTableProps = {
  rows: AdminHotelMetricRow[];
  loading?: boolean;
  context: AdminTabMetricColumnsContext;
};

export const AdminTeamHotelsTable = ({
  rows,
  loading = false,
  context,
}: AdminTeamHotelsTableProps): React.JSX.Element => {
  const { t } = useTranslation();
  const columns = React.useMemo(
    () => getAdminTabMetricColumns("team", context),
    [context],
  );

  return (
    <AdminHotelsMetricTable
      tab="team"
      columns={columns}
      rows={rows}
      loading={loading}
      emptyMessage={t(
        "analytics.admin.team.table.empty",
        "No team data for the selected period.",
      )}
    />
  );
};
